module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"virtual":"jeu de données virtuel","inc":"jeu de données éditable","metaOnly":"métadonnées seules","lines":"aucune ligne | 1 ligne | {count} lignes","draft":"brouillon"},"en":{"virtual":"virtual dataset","inc":"editable dataset","metaOnly":"metadata only","lines":"no line | 1 line | {count} lines","draft":"draft"}}')
  delete Component.options._Ctor
}
